// Material Dashboard 3 PRO React
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

import Navbar from "./navbar";
import Header from "./customstyle/header";

// Map compontnes
import CityMapComponent from "components/Map/CityMapComponent"// ethan: update the year

function Overview({url, year}) {
  return (
    <DashboardLayout>
      <Navbar year={year}/>
      <MDBox mb={2} />
      <Header>
        <MDBox pt={2} px={2} lineHeight={1.25}>
          <MDBox mb={1}>
            <CityMapComponent downloadUrl = {url}/>
          </MDBox>
        </MDBox>
      </Header>
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
